import { get, post } from "./api";

const controller = 'ConnectionBackup';

// A 403 or 404 from these calls is answered on the page. The default is a full-page redirect, which would drop
// an import review that took a while to read.
const answerInPage = { statusCodeHandlers: [403, 404].map(statusCode => ({ statusCode, handler: () => { } })) };

// Every local group with its setting: { environmentGroupId, environmentGroupName, enabled, keepCount }.
export const getBackupSettings = async () => await get(`${controller}/settings`, undefined, answerInPage);

export const saveBackupSettings = async (settings) => await post(`${controller}/settings`, settings, answerInPage);

// The environment's backups, newest first, without their content: { id, createdDate, trigger, fileCount, connectionCount }.
export const getBackups = async (templateEnvironmentId) => await get(`${controller}/environment/${templateEnvironmentId}`, undefined, answerInPage);

// One backup with its export: { backup, document }.
export const getBackup = async (backupId) => await get(`${controller}/item/${backupId}`, undefined, answerInPage);

// Answers { outcome: 'Stored' | 'Unchanged' | 'Skipped' }.
export const backUpNow = async (templateEnvironmentId) => await post(`${controller}/environment/${templateEnvironmentId}`, null, answerInPage);
